// extracted by mini-css-extract-plugin
export default {"header":"cTpz3g","headerLeftSide":"kpiqrj","headerRightSide":"fKp83Z","avatar":"y2tuxm"};